import type { PreconClientSettings } from './settings-types';
import { mergeWith, isArray } from 'lodash';

type RecursivePartial<T> = {
    [P in keyof T]?: T[P] extends (infer U)[]
        ? RecursivePartial<U>[]
        : T[P] extends object | undefined
        ? RecursivePartial<T[P]>
        : T[P];
};

export type PartialPreconClientSettings =
    RecursivePartial<PreconClientSettings>;

/**
 * Merges many client settings with each other. Former settings in the will be overwritten by the latter settings
 * in the result.
 */
export function mergeClientSettings(
    items: Iterable<PartialPreconClientSettings>
): PartialPreconClientSettings;
export function mergeClientSettings(
    items: [PreconClientSettings, ...PartialPreconClientSettings[]]
): PreconClientSettings;
export function mergeClientSettings(
    items: Iterable<PartialPreconClientSettings>
): PartialPreconClientSettings {
    let result: PartialPreconClientSettings = {};

    for (const item of items) {
        result = mergeWith(result, item, (objValue, srcValue) => {
            if (isArray(objValue)) {
                return srcValue;
            }
        });
    }

    return result;
}
